/* District Mailing — corporate theme behaviour (header, mega menu, mobile menu, reveals) */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('dm-smooth');

  function initHeader(root){
    var hdr = (root||document).querySelector('[data-dm-header]');
    if(!hdr || hdr.__dmInit) return; hdr.__dmInit = true;
    var trigger = hdr.querySelector('[data-dm-mega-trigger]');
    var mega = hdr.querySelector('[data-dm-mega]');
    var burger = hdr.querySelector('[data-dm-burger]');
    var mnav = document.querySelector('[data-dm-mnav]');
    var closeT;

    function onScroll(){ hdr.classList.toggle('is-scrolled', window.scrollY > 24); }
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

    var openedAt=0;
    function openMega(){ if(!mega) return; clearTimeout(closeT); if(!mega.classList.contains('is-open')) openedAt=Date.now(); mega.classList.add('is-open'); hdr.classList.add('is-open'); trigger.setAttribute('aria-expanded','true'); }
    function closeMega(){ if(!mega) return; mega.classList.remove('is-open'); hdr.classList.remove('is-open'); trigger.setAttribute('aria-expanded','false'); }
    if(trigger && mega){
      var item = trigger.closest('.dm-hdr__item');
      trigger.addEventListener('click', function(e){ e.preventDefault(); if(mega.classList.contains('is-open') && Date.now()-openedAt > 450){ closeMega(); } else { openMega(); } });
      var canHover = window.matchMedia('(hover: hover)').matches;
      if(canHover){
        [item, mega].forEach(function(el){
          el.addEventListener('mouseenter', openMega);
          el.addEventListener('mouseleave', function(){ closeT = setTimeout(closeMega, 180); });
        });
      }
      document.addEventListener('click', function(e){ if(!hdr.contains(e.target)) closeMega(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && mega.classList.contains('is-open')){ closeMega(); trigger.focus(); } });
      mega.addEventListener('focusout', function(e){ if(!mega.contains(e.relatedTarget) && e.relatedTarget !== trigger) closeMega(); });
    }

    function openM(){ if(!mnav) return; mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden','false'); burger.setAttribute('aria-expanded','true'); document.body.classList.add('dm-lock'); var c=mnav.querySelector('[data-dm-mnav-close]'); c && c.focus(); }
    function closeM(){ if(!mnav) return; mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden','true'); burger.setAttribute('aria-expanded','false'); document.body.classList.remove('dm-lock'); }
    if(burger && mnav){
      burger.addEventListener('click', openM);
      mnav.querySelectorAll('[data-dm-mnav-close]').forEach(function(b){ b.addEventListener('click', closeM); });
      mnav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ if((a.getAttribute('href')||'').indexOf('#')>-1) closeM(); }); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && mnav.classList.contains('is-open')){ closeM(); burger.focus(); } });
      window.addEventListener('resize', function(){ if(window.innerWidth > 989) closeM(); });
    }
  }

  function initReveal(root){
    var els = (root||document).querySelectorAll('.dm [data-dm-reveal]:not(.is-in)');
    if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)){
      els.forEach(function(el){ el.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    els.forEach(function(el){ io.observe(el); });
  }

  function init(root){ initHeader(root); initReveal(root); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
